const SvgBorder = ({ id, width = 200, height = 200, borderWidth = 10, radius = 20, color = "black", gradient, gradientAngle = 0, ...props }) => {
  
  // Convert angle to x1, y1, x2, y2 values
  const angleRad = (gradientAngle * Math.PI) / 180;
  const x1 = 50 - 50 * Math.cos(angleRad);
  const y1 = 50 - 50 * Math.sin(angleRad);
  const x2 = 50 + 50 * Math.cos(angleRad);
  const y2 = 50 + 50 * Math.sin(angleRad);
  
  return (
      <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`} {...props} >
        {gradient && (
          <defs>
            <linearGradient id={id} x1={`${x1}%`} y1={`${y1}%`} x2={`${x2}%`} y2={`${y2}%`}>
              {gradient.map((stop, index) => (
                <stop key={index} offset={stop.offset} stopColor={stop.color} />
              ))}
            </linearGradient>
          </defs>
        )}
        <rect
          x={borderWidth / 2}
          y={borderWidth / 2}
          width={width - borderWidth}
          height={height - borderWidth}
          rx={radius}
          ry={radius}
          stroke={gradient ? `url(#${id})` : color}
          strokeWidth={borderWidth}
          fill="none"
        />
      </svg>
    );
  };
  
  export default SvgBorder;